import axiosClient from '../axiosClient';
import { ProductStockSubscriptionsEndpoint } from '../endpoints/productStockSubscriptions';
import {
  IGetProductStockSubscriptionsResponse,
  IProductStockSubscriptionSearchParams,
} from '../../types/api/response/productstocksubscriptionsresponse';

export const ProductStockSubscriptionsService = {
  async getPendingSubscriptions(
    params: IProductStockSubscriptionSearchParams,
  ): Promise<IGetProductStockSubscriptionsResponse> {
    const res = await axiosClient.get<IGetProductStockSubscriptionsResponse>(
      ProductStockSubscriptionsEndpoint.GET_PENDING_SUBSCRIPTIONS,
      { params },
    );
    return res.data;
  },
};
